import { useEffect, useRef, useState } from 'react'
import { LogOut, UserRound } from 'lucide-react'
import { useFeatureDispatch, useFeatureSelector } from '@/platform/state/hooks'
import { clearSessionTokens } from './sessionTokens'
import { sessionActions } from './sessionSlice'

export function UserAvatarMenu() {
  const [open, setOpen] = useState(false)
  const [failedAvatar, setFailedAvatar] = useState<string | null>(null)
  const menuRef = useRef<HTMLDivElement>(null)
  const dispatch = useFeatureDispatch()
  const user = useFeatureSelector((state) => state.session.user)

  useEffect(() => {
    const close = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [])
  if (!user) return null
  const name = user.display_name || user.email
  const initial = name.trim().charAt(0).toLocaleUpperCase('vi-VN') || '?'
  const avatarColors = [
    ['#dbeafe', '#1d4ed8'], ['#dcfce7', '#15803d'], ['#fef3c7', '#b45309'], ['#fce7f3', '#be185d'],
    ['#ede9fe', '#6d28d9'], ['#cffafe', '#0e7490'], ['#ffedd5', '#c2410c'], ['#e2e8f0', '#334155'],
  ] as const
  const colorIndex = (initial.codePointAt(0) ?? 0) % avatarColors.length
  const [avatarBackground, avatarForeground] = avatarColors[colorIndex]
  const showAvatarImage = Boolean(user.avatar && failedAvatar !== user.avatar)
  const logout = () => {
    clearSessionTokens()
    dispatch(sessionActions.anonymous())
    setOpen(false)
  }

  return <div className="user-menu" ref={menuRef}>
    <button type="button" className="user-menu-trigger" onClick={() => setOpen((value) => !value)} aria-label="Mở menu tài khoản" aria-expanded={open}>
      {showAvatarImage
        ? <img src={user.avatar!} alt="" onError={() => setFailedAvatar(user.avatar)} />
        : <span className="user-initial" style={{ backgroundColor: avatarBackground, color: avatarForeground }}>{initial}</span>}
      <span className="user-menu-name">{name}</span>
    </button>
    {open && <div className="user-menu-popover"><div className="user-summary"><UserRound size={16} /><span><strong>{name}</strong><small>{user.email}</small></span></div><button type="button" onClick={logout}><LogOut size={16} />Đăng xuất</button></div>}
  </div>
}
